import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";


class EspeciesCantidadIncidencias extends Component {
  
  componentDidMount () {
  
    
  }
  render () {
   //[{year: 2002, value: 10.5}]
    let names = this.props.data.map(item => item.name)
      .filter((a, b, c) => c.indexOf(a) === b)
    
    let paises =  this.props.data.map(item => item.destination_f).filter((a, b, c) => c.indexOf(a) === b)
    let dataParseA = []
    paises.forEach((itemP, indexP) => {
        let preRow = new Array(names.length)
        preRow.fill(0)

        names.forEach((item, index) => {
          let f = this.props.data.findIndex(itemD => {
            return itemD.destination_f === itemP && itemD.name === item
          })
          
          if (f >= 0) {
            preRow[index] = +this.props.data[f].cantidad
            // copy.splice(f, 1)
          }
        })
        dataParseA.push({name: itemP,  data: preRow})
    })
    
    return this.props.data.length > 0 ?  
    <>
    { createHChart('chartMDEspeciesCantidadIncidencias',
              {
                  
                  chart: { type: 'bar' },
                  title: {
                      text: this.props.title
                  },
                  xAxis: { 
                    title: { 
                      text: 'Especies',
                    enabled: false
                    }, 
                    categories: names
                  },
                  yAxis: {
                    
                      min: 0,
                      title: {
                          text: 'Cantidad',
                          enabled: false
                      }
                  },
                  // legend: { enabled: false },
                  plotOptions: {
                      series: {
                          stacking: 'normal',
                          pointWidth: 40
                      }
                  },
                  series: dataParseA
              }
            ) }
            <div style={{fontSize: '0.9em'}}>

              <div className="has-text-centered" style={{fontSize: '0.9em'}}>
                <p className="px-6" style={{
                color: '#000',
                fontSize: '1.1em',
                
                fill: '#000'
                }}><i>{ this.props.description }</i></p>
              </div>
              </div>
              </>
            : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(EspeciesCantidadIncidencias)